import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\accountant\\accountant-menu.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\accountant\\clients\\client-items.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\accountant\\clients\\manage-clients.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\admin-menu.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-accountant\\create-client-accountant.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-accountant\\delete-client-accountant.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-accountant\\manage-accountant.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-accountant\\manage-client-accountant.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-accountant\\update-client-accountant.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-backups\\client-backup-items.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-backups\\manage-client-backups.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-seller\\create-client-seller.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-seller\\delete-client-seller.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-seller\\manage-client-seller.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-seller\\manage-seller.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\client-seller\\update-client-seller.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\comments\\feedbacks\\delete-feedback.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\comments\\feedbacks\\manage-feedbacks.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\comments\\feedbacks\\update-feedback.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\comments\\questions\\delete-question.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\comments\\questions\\manage-questions.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\comments\\questions\\update-question.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\docs\\manage-docs.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\users\\create-user.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\users\\delete-user.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\users\\manage-users.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\users\\update-user.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\users\\user-logs.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\visitors\\delete-visitor.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\visitors\\manage-visitors.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\admin\\visitors\\update-visitor.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\all\\manage-self-user.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\all\\update-self-user-form.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\client\\client-menu.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\auth\\seller\\seller-menu.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\ui\\button.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\ui\\changePassword.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\ui\\confimPassword.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\ui\\replyMessage.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\ui\\textInputMask.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\ui\\textInputSearch.tsx");
;
import(/* webpackMode: "eager" */ "Y:\\Desenv\\Site\\Produção\\Completo\\frnt\\sig\\src\\components\\ui\\textInputUpperCase.tsx");
